import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SignupService {
  private apiPath = environment.apiServer;

  signup(formData: any) {
    let fetchData = {
      oid: environment.oid,
      retURL: environment.retURL,
      country_code: environment.countryCode,
      lead_source: environment.leadSource,
      MVN_Interaction_Type__c: environment.MVN_Interaction_Type__c,
      MVN_Receive_Direct_Email__c: '1',
      MVN_Privacy_Consent__c: '1',
      '00NRh000002o9v0': '1',
      '00NRh000002o9mw': '1',
      MVN_I_am_at_least_18_years_old__c: formData.eighteenYears ? '1' : '0',
      MVN_Receive_Direct_Text__c: formData.agreeSMS ? '1' : '0',
      MVN_Received_Direct_Mail__c: formData.receiveDirect ? '1' : '0',
      MVN_Screening_For__c: formData.screening,
      first_name: formData.firstname,
      last_name: formData.lastname,
      email: formData.email,
      phone: formData.phone,
      street: formData.addressOne,
      MVN_Address_2__c: formData.addressTwo,
      city: formData.city,
      state_code: formData.state || '',
      zip: formData.zipcode,
      // MVN_Family_Type_1_History__c: formData.noradioscreening || '',
      // '00NRh000000JCaC': formData.noradioscreening || '',
      '00NRh00000C7QAG': formData.contactpreference || '',
    };

    let newFetchData = {
      '00NRh00000C7QAC': formData.noradioscreening.includes('00NRh00000C7QAC')
        ? '1'
        : '0',
      '00NRh00000C7QAD': formData.noradioscreening.includes('00NRh00000C7QAD')
        ? '1'
        : '0',
      '00NRh00000C7QAE': formData.noradioscreening.includes('00NRh00000C7QAE')
        ? '1'
        : '0',
      '00NRh00000C7QAF': formData.noradioscreening.includes('00NRh00000C7QAF')
        ? '1'
        : '0',
      ...fetchData,
    };

    return fetch(`${this.apiPath}`, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(newFetchData),
    });
  }
}
